import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import CarProgramOption from '@/earn/enums/car-program/car-program-option';
import Rep from '@/_shared/entities/rep/rep.entity';
import Service from '@/earn/services/car-program.service';

@Component
export default class PaymentOptionsMixin extends Vue {
  @Prop({ type: String, default: CarProgramOption.ACCRUAL })
  public programOption!: CarProgramOption;

  @Prop({ type: Number, required: true })
  public programRankType!: number;

  accrual = CarProgramOption.ACCRUAL;
  car = CarProgramOption.CAR;
  cash = CarProgramOption.CASH;
  showConfirmationModal = false;
  showLearnMoreModal = false;
  loading = false;
  selectedOption: CarProgramOption = CarProgramOption.ACCRUAL;
  chosenOption: CarProgramOption = CarProgramOption.ACCRUAL;

  get rep(): Rep {
    return this.$store.state.RepStore.rep;
  }

  created() {
    this.setDefaultOption();
  }

  setDefaultOption(): void {
    this.selectedOption = this.programOption;
  }

  isSelected(option: string): boolean {
    return this.selectedOption === option;
  }

  choseOption(chosenOption: CarProgramOption): void {
    this.selectedOption = this.programOption;
    this.chosenOption = chosenOption;
    this.showConfirmationModal = true;
  }

  openLearnMoreModal(): void {
    this.showLearnMoreModal = true;
  }

  setOption(): void {
    const payload = { option: this.chosenOption };
    this.loading = true;
    Service.putCarProgramOption(this.rep.did, this.programRankType, payload)
      .then(() => {
        this.$emit('program-option-selected', this.chosenOption);
      })
      .finally(() => {
        this.loading = false;
        this.showConfirmationModal = false;
      });
  }

  @Watch('programOption')
  changeSelectedOption() {
    this.selectedOption = this.programOption;
  }
}
